/* eslint-disable no-prototype-builtins */
import * as React from 'react'
import axios from 'axios'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'

import { positionChangeHeightSm, positionChangeWidthMd, positionChangeWidthSm, swipelyticsPink, profileTypes, profileVibes } from '../../../../helpers/variableDefaults'
import { standardButton, exitModalIconButton } from '../../../../helpers/buttons'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { newSimulationTextField } from '../../../../helpers/textfields'
import { validEmail, removeDuplicatesFromArray, noDuplicatesInArray, capitalizeFirstLetter } from '../../../../helpers/globalHelpers'
import { standardErrorContainer } from '../../../../helpers/errors'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { selectElementHandleChange, selectMultiple } from '../../../../helpers/selects'
import { doneAndCancelButtonsJSX } from '../../../../helpers/commonJSX'
import { advisoryTypography } from '../../../../helpers/typographies'
import { descriptionTextFieldNoIndexOrChangeHandler } from '../../../../helpers/textfields'

export const selectAboutMeModalJSX = (
  user, 
  datingProfile, setDatingProfile, 
  previousDatingProfile, setPreviousDatingProfile, 
  newAboutMe, setNewAboutMe,
  openAboutMeSelectModal, setOpenAboutMeSelectModal,
  customAboutMeSelected, setCustomAboutMeSelected,
  loading, setLoading,
  errors, setErrors,
  saveSuccessful, setSaveSuccessful,
  width
) => {

  const arrayOfAboutMes = removeDuplicatesFromArray([ 
    'No About Me',
    ...user.bio.aboutMe,
    'Custom'  
  ])

  if ('aboutMe' in datingProfile.bio && datingProfile.bio.aboutMe.length > 0 && arrayOfAboutMes.filter((aboutMeInArray, aboutMeInArrayIndex) => aboutMeInArray === datingProfile.bio.aboutMe).length === 0) {
    arrayOfAboutMes.splice(arrayOfAboutMes.length - 1, 0, datingProfile.bio.aboutMe)
  }

  const handleClose = () => {
    // console.log('handleClose runs ->')
    // console.log('openAboutMeSelectModal ->', openAboutMeSelectModal)

    setNewAboutMe('')
    setCustomAboutMeSelected(false)
    setOpenAboutMeSelectModal(false)
  }

  const handleDone = async () => {
    console.log('handleDone runs')
    
    const newBio = { ...datingProfile.bio, aboutMe: newAboutMe }
    setDatingProfile({ ...datingProfile, bio: { ...newBio } })

    setNewAboutMe('')
    setCustomAboutMeSelected(false)
    setOpenAboutMeSelectModal(false)
  }

  const selectAboutMe = (e, userAboutMeIndex) => {
    e.preventDefault()
    // console.log('selectAboutMe runs')

    if (arrayOfAboutMes[userAboutMeIndex] !== 'Custom') {
      const chosenAboutMe = arrayOfAboutMes[userAboutMeIndex] === 'No About Me' ? '' : arrayOfAboutMes[userAboutMeIndex]

      const newBio = { ...datingProfile.bio, aboutMe: chosenAboutMe }
      setDatingProfile({ ...datingProfile, bio: { ...newBio } })

      setNewAboutMe('')
      setCustomAboutMeSelected(false)
      setOpenAboutMeSelectModal(false)
    } else {
      setCustomAboutMeSelected(true)
    }
  }


  const doneButtonDisabled = () => {
    return (
      'aboutMe' in datingProfile.bio && datingProfile.bio.aboutMe.length > 0
        ?
        newAboutMe === datingProfile.bio.aboutMe
        :
        newAboutMe.length === 0
    )
  }

  const aboutMeIsSelected = (selectedAboutMeIndexOnArray) => {
    return (
      newAboutMe === arrayOfAboutMes[selectedAboutMeIndexOnArray]
      || 
      (
        newAboutMe === ''
        && arrayOfAboutMes[selectedAboutMeIndexOnArray] === 'No About Me'
      )
    )
  }

  const aboutMeItemsJSX = () => {
    return (
      <>
        {arrayOfAboutMes.map((aboutMeOnArray, aboutMeIndexOnArray) => (
          <Box
            key={aboutMeIndexOnArray}
            onClick={(e) => selectAboutMe(e, aboutMeIndexOnArray)}
            disabled={false}
            sx={{
              mt: 2,
              width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
              backgroundColor: 'white',
              boxShadow: 3, 
              borderRadius: '5px',
              border: aboutMeIsSelected(aboutMeIndexOnArray) ? 2 : 0,
              borderColor: aboutMeIsSelected(aboutMeIndexOnArray) ? 'blue' : 'black',
              cursor: 'pointer',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
            }}
          >
            {/* About Me */}
            <Typography
              sx={{
                px: 2, py: 1.5,
                width: '100%',
                // fontWeight: 'bold',
              }}
            >
              {aboutMeOnArray}
            </Typography>
              
          </Box>
        ))}
      </>
    )
  }

  return (
    <Modal
      open={openAboutMeSelectModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box 
        sx={{ 
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'translate(-50%, -50%)',
          // width: width < positionChangeWidthSm ? '85%' : '450px',
          width: '85%',
          height: '85%',
          bgcolor: 'white',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4, 
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: 'rgba(0, 0, 0, .35)',
            webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
          },
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%', height: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {/* Exit Icon Button */}
          <Box
            sx={{
              mr: 0,
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center',
            }}
          >
            {exitModalIconButton(handleClose, false, 0, 1, 1)}
          </Box>

          {/* Title */}
          <Typography
            sx={{
              mt: 2,
              fontSize: '22px',
              fontWeight: 'bold',
            }}
          >
            Select About Me
          </Typography>

          <Box
            sx={{
              my: -2,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            {advisoryTypography(
              `'About Me' elements can be edited in the 'Bio' tab of your dashboard`
            )}
          </Box>

          {/* List of About Mes */}
          {!customAboutMeSelected 
            && 
            (
              user.bio.aboutMe.length > 0
              && user.bio.aboutMe.filter((aboutMeItem, aboutMeItemIndex) => aboutMeItem.length > 0).length > 0
            )
            ?
            aboutMeItemsJSX()
            :
            <Box
              sx={{
                mt: 2,
                width: '90%',
                maxWidth: '450px',
              }}
            >
              {descriptionTextFieldNoIndexOrChangeHandler(
                'aboutMe',
                newAboutMe,
                ``,
                5,
                300,
                'Describe yourself in a few sentences',
                false,
                setNewAboutMe,
                newAboutMe,
                0
              )}
            </Box>
          }

          
          {/* Create and Cancel Buttons */}
          {doneAndCancelButtonsJSX(
            'Done',
            'Cancel',
            doneButtonDisabled(),
            false,
            handleDone,
            handleClose,
            0,
            0,
            0,
            width,
            'warning',
            'secondary'
          )}

          {errors.selectAboutMe &&
            standardErrorContainer(
              'There was an error updating your media item. Check your Internet connection and try again.',
              1,
              1
            )
          }
        </Box>
      </Box>
    </Modal>
  )
}